<xemex-dialog-shell [title]="'devices.detailTabs.verification.details.label' | translate">
  <div class="border border-border-card rounded-lg p-2 overflow-scroll">
    <div class="grid lg:grid-cols-2 gap-x-6">
      <mat-form-field class="w-full readonly-disabled">
        <mat-label>{{ 'devices.detailTabs.verification.initiatedBy' | translate }}</mat-label>
        <input
          type="text"
          matInput
          [value]="verificationDetails()?.initiatedBy ?? data.initiatedBy"
          readonly
          disabled
        />
      </mat-form-field>
      <mat-form-field class="w-full readonly-disabled">
        <mat-label>{{ 'devices.detailTabs.verification.initiatedOn' | translate }}</mat-label>
        <input
          type="text"
          matInput
          [value]="
            verificationDetails()?.initiatedOn ?? data.initiatedOn | date: 'HH:mm:ss dd MMM yyyy'
          "
          readonly
          disabled
        />
      </mat-form-field>
      <mat-form-field class="w-full readonly-disabled">
        <mat-label>{{ 'devices.detailTabs.verification.status' | translate }}</mat-label>
        <input
          type="text"
          matInput
          [value]="verificationDetails()?.status ?? data.status"
          readonly
          disabled
        />
      </mat-form-field>
      <mat-form-field class="w-full readonly-disabled">
        <mat-label>{{ 'devices.detailTabs.verification.error' | translate }}</mat-label>
        <input
          type="text"
          matInput
          [value]="verificationDetails()?.error ?? data.error"
          readonly
          disabled
        />
      </mat-form-field>
    </div>
    @if (deviceStore.isLoadingVerificationDetails()) {
      <xemex-spinner />
    }
    @if (hasFinishedWithoutResults()) {
      <p class="py-4 text-center text-xs font-bold">
        {{ 'devices.detailTabs.verification.details.noRegisters' | translate }}
      </p>
    }
    <mat-accordion multi>
      @for (channel of verificationDetails()?.results?.channels ?? []; track $index) {
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title
              >{{ 'settings.third.dialog.details.channel' | translate }} #{{
                channel.channelNumber
              }}</mat-panel-title
            >
            <mat-panel-description
              >{{ channel.description }} ({{ channel.data.length }}
              {{
                'devices.detailTabs.verification.details.registers' | translate
              }})</mat-panel-description
            >
          </mat-expansion-panel-header>
          @for (register of channel.data; track $index) {
            <div
              class="border border-border-card rounded-xl mt-1 p-1 text-body hover:bg-primary-hover"
            >
              <div class="flex items-center gap-3 whitespace-nowrap">
                <div class="w-[25%] text-ellipsis overflow-hidden" [title]="register.name">
                  {{ register.name }}
                </div>
                <div
                  class="w-[20%] grow text-right text-ellipsis overflow-hidden"
                  [class.text-text-muted]="!wasRead(register)"
                >
                  @if (wasRead(register)) {
                    {{ register.value | json }}
                  } @else {
                    &mdash;
                  }
                </div>
                <div class="w-[5%] text-ellipsis overflow-hidden">{{ register.unit }}</div>
                <div class="w-[12%] text-right text-xs text-text-muted">
                  @if (ageLabel(register); as age) {
                    {{ 'devices.detailTabs.verification.details.age' | translate: { age: age } }}
                  }
                </div>
                <div class="w-[15%] flex justify-end">
                  @if (register.readStatus) {
                    <xemex-status-chip
                      [status]="readStatusChip(register.readStatus)"
                      [label]="readStatusLabel(register.readStatus) | translate"
                    />
                  }
                </div>
              </div>
              @if (register.message) {
                <div class="mt-1 px-1 text-xs text-text-secondary whitespace-normal">
                  {{ register.message }}
                </div>
              }
            </div>
          }
        </mat-expansion-panel>
      }
    </mat-accordion>
  </div>
  <mat-dialog-actions actions>
    <button mat-stroked-button mat-dialog-close type="button">
      {{ 'general.btnClose' | translate }}
    </button>
  </mat-dialog-actions>
</xemex-dialog-shell>
